// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3AMgI","detailsBorder":"styles_detailsBorder__kmMPJ"};